import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { fetchProjectTimeline } from '../api/projects.api';
import { queryKeys } from '@/shared/lib/queryKeys';
import type { Id, ProjectTimelineEntry } from '@/shared/types/domain';

/** Transição e mudança de campo, unidas (US-24, §4.7). */
export function useProjectTimeline(id: Id | undefined): UseQueryResult<ProjectTimelineEntry[]> {
  return useQuery({
    queryKey: queryKeys.projects.timeline(id ?? ''),
    queryFn: () => fetchProjectTimeline(id as Id),
    enabled: Boolean(id),
    staleTime: 30_000,
  });
}
